// Must stay the first import: see the module's comment.
import './shared/zodConfig';
import React, { type ComponentType } from 'react';
import { createRoot } from 'react-dom/client';

import { HashRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import '@fontsource-variable/inter';
import '@fontsource-variable/playfair-display';
import './shared/assets/base.scss';
import App from './App';
import { queryClient } from './shared/queryClient';
import ErrorBoundary from './shared/components/ErrorBoundary';

const rootElement = document.getElementById('root')!;

const renderApp = (Component: ComponentType) => (
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <HashRouter>
          <Component />
        </HashRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

const root = createRoot(rootElement);
root.render(renderApp(App));

// Vite HMR
if (import.meta.hot) {
  import.meta.hot.accept('./App', (newModule) => {
    if (newModule) {
      root.render(renderApp(newModule.default as ComponentType));
    }
  });
}
